import React from "react"

import * as style from "./Title.module.scss"

import Name from "./Name"
import Type from "./Type"
import Extras from "./Extras"

const Title = ({
  param, parent, hideExtras, microcopy,
}) => (
  <div className={style.title}>
    {param.key && <Name param={param} parent={parent} />}
    <Type param={param} microcopy={microcopy} />
    {!hideExtras && (
      <Extras param={param} parent={parent} microcopy={microcopy} />
    )}
  </div>
)

export default Title
